import {
    ADTAdapter,
    DataPusher as DataPusherCard,
    Locale
} from '@microsoft/iot-cardboard-js';
import { useThemeContext } from '../../../Theming/ThemeProvider';
import { useLanguageContext } from '../../../Models/Context/I18nProvider';
import MsalAuthService from '../../../Services/MsalAuthService';
import { useContext } from 'react';
import { AppContext } from '../../App/App';
import { getSecureUrlObjFromString } from '../../../Services/Utils';

const DataPusher = () => {
    const { selectedTheme } = useThemeContext();
    const { selectedLang } = useLanguageContext();
    const { selectedAdtUrl } = useContext(AppContext);

    return (
        <div style={{ height: '700px', width: '700px', padding: '20px' }}>
            <DataPusherCard
                theme={selectedTheme}
                locale={selectedLang as Locale}
                adapter={
                    new ADTAdapter(
                        getSecureUrlObjFromString(selectedAdtUrl)?.hostname ||
                            '',
                        {
                            login: () => {},
                            getToken: MsalAuthService.getAdtToken
                        }
                    )
                }
                initialInstanceUrl={
                    getSecureUrlObjFromString(selectedAdtUrl)?.hostname
                }
                disablePastEvents={true}
            />
        </div>
    );
};

export default DataPusher;
